// export const BASE_URL = "http://127.0.0.1:5000";
export const BASE_URL = "https://heartlandacademy.edu.np";
